export function taxNoKindEmpty(kindNoElem, taxNoElem) {
  if (!kindNoElem || !taxNoElem) return

  const wasDisabled = taxNoElem.disabled
  const shouldDisable = (kindNoElem.value === "empty")

  taxNoElem.disabled = shouldDisable

  if (shouldDisable) {
    taxNoElem.setAttribute("value-was", taxNoElem.value)
    taxNoElem.value = ""
  } else if (wasDisabled) {
    taxNoElem.value = taxNoElem.getAttribute("value-was")
  }
}

export function taxNoKindPlaceholder(kindNoElem, taxNoElem) {
  if (!kindNoElem || !taxNoElem) return

  if (kindNoElem.value === "nip_with_id") {
    taxNoElem.setAttribute("placeholder", "1234567890-12345")
  } else {
    taxNoElem.removeAttribute("placeholder")
  }
}
